import RecurringTasksItem from './RecurringTasksItem';

export default RecurringTasksItem;
